import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PresenceSolid8X8Icon(props, ref) {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 8 8",
    ref: ref,
    ...props,
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M8 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "a",
        children: /*#__PURE__*/_jsx("path", {
          d: "M0 0h8v8H0z"
        })
      })
    })]
  });
}
;
PresenceSolid8X8Icon.displayName = "PresenceSolid8X8Icon";
export default forwardRef(PresenceSolid8X8Icon);